/**
 * Cliente HTTP de preparar el envío: wrappers tipados sobre `req()` de campana-nueva. Nunca se manda el comercio (sale
 * del token). Es del equipo: con el token de una persona de un cliente, el backend dice 403.
 */

import { descargarBinario, req } from "../campana-nueva/api";
import type { Resp } from "../wa-oficial/api";
import { slug } from "../segmentaciones/logic/segmentar";
import type * as T from "./types";

const ruta = (id: string) => `/activa/segmentaciones/${encodeURIComponent(id)}/envio`;
const rutaDelResultado = (id: string) => `/activa/segmentaciones/${encodeURIComponent(id)}/resultado`;

export const enviosApi = {
  ver: (id: string): Promise<Resp<T.EstadoEnvio | null>> => req("GET", ruta(id)),
  preparar: (id: string): Promise<Resp<T.Preparacion>> => req("POST", ruta(id)),
  /** Las campañas de Snov de la marca, para vincular las que mandan los grupos de mail. */
  snov: (id: string): Promise<Resp<T.SnovDelEnvio>> => req("GET", `${ruta(id)}/snov`),
  vincularSnov: (id: string, snovIds: number[]): Promise<Resp<T.SnovDelEnvio>> => req("PUT", `${ruta(id)}/snov`, { snovIds }),
  listaSnov: (id: string, grupo: string): Promise<Resp<T.ListaParaSnov>> => req("GET", `${ruta(id)}/snov/lista?grupo=${encodeURIComponent(grupo)}`),
  htmlSnov: (id: string, grupo: string): Promise<Resp<T.HtmlParaSnov>> => req("GET", `${ruta(id)}/snov/html?grupo=${encodeURIComponent(grupo)}`),
  /** El resultado contra el control (fase 5). Sin el envío preparado, 409 SIN_PREPARAR. */
  resultado: (id: string): Promise<Resp<T.Resultado>> => req("GET", rutaDelResultado(id)),
  /** Las estadísticas de la marca: la suma de los resultados de sus campañas en el período (fase 5c). */
  estadisticas: (periodo: T.Periodo): Promise<Resp<T.Estadisticas>> => req("GET", `/activa/estadisticas?periodo=${encodeURIComponent(periodo)}`),
  /** La lectura del cliente en PDF, con «Tu marca». */
  pdfDelResultado: (c: { id: string; nombre: string }): Promise<void> => descargarBinario(`${rutaDelResultado(c.id)}/pdf`, `${slug(c.nombre)}-resultado.pdf`),
};
